// extracted by mini-css-extract-plugin
export var cancelButton = "_mo-5";
export var content = "_mo-3";
export var createButton = "_mo-6";
export var drawerContainer = "_mo-0";
export var footer = "_mo-2";
export var header = "_mo-1";
export var orderFormColumn = "_mo-4";